module.exports = __webpack_public_path__ + "img/play.a2da0b6a.svg";